const RussiaSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_112218)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F0F0F0"
      />
      <path
        d="M38.756 26.9559C39.56 24.7893 40 22.4459 40 19.9995C40 17.553 39.56 15.2096 38.756 13.043H1.24398C0.440078 15.2096 0 17.553 0 19.9995C0 22.4459 0.440078 24.7893 1.24398 26.9559L20 28.6951L38.756 26.9559Z"
        fill="#0052B4"
      />
      <path
        d="M19.9997 40.0005C28.599 40.0005 35.9298 34.573 38.7557 26.957H1.24365C4.06951 34.573 11.4004 40.0005 19.9997 40.0005Z"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_112218">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default RussiaSvg;
